import React, { useEffect } from 'react';
import PageLayout from '../../components/PageLayout';
import DashboardDetails from './DashboardDetails';
import { useDispatch } from 'react-redux';
import { getPanelsData } from '../../store/dashboard/dashboardActions';

export default function Dashboard() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch( getPanelsData() );
  }, [ dispatch ]);

  return (
    <PageLayout
      details={<DashboardDetails />}
    />
  );
}
